// extracted by mini-css-extract-plugin
module.exports = {"toolTip":"ToolTip_toolTip__1trNL","small":"ToolTip_small__b7KVF"};